import { useEffect, useState } from 'react'
import { Button, Chip, Typography } from 'amo-styling-library'
import { DataGrid } from '@mui/x-data-grid'
import { SimpleDashboardLayout } from '../components/layout/SimpleDashboardLayout'
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { ButtonSize, GlobalRadius, Border } from 'amo-styling-library'
import { API_ENDPOINTS } from '../config/api'

interface User {
  id: string
  firstName: string
  lastName: string
  email: string
  role: string
  status: 'Active' | 'Inactive'
  phoneNumber: string
  verifiedAt: string | null
}

function DashboardPage() {
  const [users, setUsers] = useState<User[]>([])
  const [loading, setLoading] = useState(true)

  const fetchUsers = () => {
    setLoading(true)
    console.log('Fetching users from:', API_ENDPOINTS.users)
    fetch(API_ENDPOINTS.users)
      .then(res => res.json())
      .then(data => {
        console.log('Users response:', data)
        console.log('Number of users:', data.users?.length)
        setUsers(data.users || [])
        setLoading(false)
      })
      .catch(err => {
        console.error('Failed to load users:', err)
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  const columns: GridColDef[] = [
    {
      field: 'firstName',
      headerName: 'First Name',
      flex: 1,
      minWidth: 120
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      flex: 1,
      minWidth: 120
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1.5,
      minWidth: 200
    },
    {
      field: 'role',
      headerName: 'Role',
      flex: 0.8,
      minWidth: 100
    },
    {
      field: 'phoneNumber',
      headerName: 'Phone Number',
      flex: 1.2,
      minWidth: 150
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.8,
      minWidth: 100,
      renderCell: (params: GridRenderCellParams) => (
        <Chip
          label={params.value as string}
          status={params.value === 'Active' ? 'success' : 'error'}
        />
      )
    },
    {
      field: 'verifiedAt',
      headerName: 'Verified At',
      flex: 1,
      minWidth: 150,
      renderCell: (params: GridRenderCellParams) => {
        const value = params.value as string | null
        return value ? new Date(value).toLocaleDateString('nl-BE') : '-'
      }
    }
  ]

  return (
    <SimpleDashboardLayout>
      <div className="bg-white rounded-lg p-6 h-full">
        <div className="flex justify-between items-center mb-6">
          <Typography variant="h2" className="text-gray-900">
            Gebruikersbeheer
          </Typography>
          <div className="flex gap-3">
            <Button
              label="Ververs"
              size={ButtonSize.MEDIUM}
              radius={GlobalRadius.ROUNDED}
              border={Border.BORDER}
              onClick={fetchUsers}
            />
          </div>
        </div>

        {loading ? (
          <p className="text-gray-600">Laden...</p>
        ) : (
          <>
            <div className="mb-4 text-sm text-gray-600">
              Totaal {users.length} gebruikers
            </div>
            <div style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={users}
                columns={columns}
                pageSizeOptions={[5, 10, 25]}
                initialState={{
                  pagination: { paginationModel: { pageSize: 10 } },
                }}
              />
            </div>
          </>
        )}
      </div>
    </SimpleDashboardLayout>
  )
}

export default DashboardPage
